import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from "@angular/core";
//import { Router } from '@angular/router';
import { AuthService } from "@services/auth.service";
import { UserClassesService } from "@services/user-classes.service";
import { UserClassesStateService } from "@services/user-classes-state.service";
import { UserClassesTaken } from "@models/user-classes-taken";
import { AlertifyService } from "@services/alertify.service";
import { ClassService } from "@services/class.service";
import { classItem } from "@models/classItem";
import { MatDialog } from "@angular/material/dialog";
import { PopupComponent } from "@components/popup/popup.component";
// import {List, Item} from 'linked-list'
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-classes",
  templateUrl: "./classes.component.html",
  styleUrls: ["./classes.component.css"],
})
export class ClassesComponent implements OnInit, AfterViewInit {
  videoUrl = "";
  height: number = 400; //default value
  @ViewChild("card2", { static: true }) MyDOMElement: ElementRef;
  testvar: string = "22";  //...

  userClassesList: classItem[]; //list of all classes
  userClassesTakenList: UserClassesTaken[]; // list of classes completed by the student
  //userClassesList: [Class][UserClassesTaken];
  userClassesListds = new Map(); //list of classes and reference classes completed by the student
  //userClassesListds.get(userClasses) = userClasseslist[10], userClassesList.get(userClassesTaken) = userClassesTakenList[10]

  // Instructions panel state
  isInstructionsExpanded: boolean = true;

  clist: (classItem | UserClassesTaken)[][];
  // clist: any[];
  //containingList: any[10] = [[],[]],[[],[]];

  constructor(
    public authService: AuthService,
    private userClassesService: UserClassesService,
    private alertify: AlertifyService,
    public classService: ClassService,
    private dialogRef: MatDialog,
    private userClassesStateService: UserClassesStateService
  ) {}

  ngOnInit() {
    // Load user classes using the new state service
    this.userClassesStateService.loadUserClasses().subscribe();
    
    // Subscribe to normalized user classes data
    this.userClassesStateService.userClasses$.subscribe(classes => {
      this.userClassesTakenList = classes;
      this.userClassesListds = this.userClassesStateService.getClassesAsMap();
    });

    this.GetAllClasses();
  }

  ngAfterViewInit() {}

  openDialog() {
    this.dialogRef.open(PopupComponent, {
      data: {
        name: "Samuel",
      },
    });
  }

  GetAllClasses() {
    this.classService.getAllClasses().subscribe(
      (userClasses: classItem[]) => {
        this.userClassesList = userClasses;
      },
      (error) => {
        this.alertify.error(error);
      },
      () => {
        // third part , complete
        //do nothing
      }
    );
  }

  /**
   * TrackBy function for improved performance in ngFor loop
   * Helps Angular track changes efficiently
   */
  trackByClassId(index: number, userClass: classItem): number {
    return userClass.id;
  }

  /**
   * Toggle the instructions panel visibility
   */
  toggleInstructions(): void {
    this.isInstructionsExpanded = !this.isInstructionsExpanded;
  }

  /**
   * Scroll smoothly to the classes grid section
   */
  scrollToClasses(): void {
    const element = document.getElementById('classesGrid');
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }
}
